// Module
var code = "<sw-page> <sw-card class=\"login\"> <sw-card-header>{{ 'login.login_title' | translate }}</sw-card-header> <sw-card-main> <login-widget success=\"$ctrl.onSuccess()\"></login-widget> </sw-card-main> </sw-card> </sw-page> ";
// Exports
export default code;